import { useMemo } from "react";

import { useIsStandardToPremiumUpgradeEligible } from "@/components/user-context/helpers/cohorts";
import { experiments } from "@/utils/experiment/manifest";
import { getExperiment } from "@/utils/experiment/use-experiment";
import { useExperimentExposure } from "@/utils/experiment/use-experiment-exposure";

export type UpgradeWacExperimentType = {
    isPartOfUpgradeWacExperimentAudience: boolean;
    cohort: "variation" | "control" | undefined;
    exposureFired: boolean;
    fireExposure: () => void;
};

/**
 * Checks if the user is enrolled in the upgrade WAC experiment and returns the cohort
 * @returns {UpgradeWacExperimentType} The upgrade WAC experiment
 */
export function useGetUpgradeWacExperiment(): UpgradeWacExperimentType {
    // Upgrade S2P Experiment
    const isStandardToPremiumUpgradeEligible =
        useIsStandardToPremiumUpgradeEligible();
    const upgradeWacExperimentObj = experiments.twcg907Astro540WacUpgradeS2p;
    const [exposureFired, fireExposure] = useExperimentExposure(
        upgradeWacExperimentObj
    );
    const upgradeWacExperiment = getExperiment(upgradeWacExperimentObj);
    const isPartOfUpgradeWacExperimentAudience =
        isStandardToPremiumUpgradeEligible &&
        upgradeWacExperiment.type === "enrolled";
    const cohort = isPartOfUpgradeWacExperimentAudience
        ? upgradeWacExperiment.value
        : undefined;

    return useMemo(() => {
        return {
            isPartOfUpgradeWacExperimentAudience,
            cohort,
            exposureFired,
            fireExposure
        };
    }, [
        isPartOfUpgradeWacExperimentAudience,
        cohort,
        exposureFired,
        fireExposure
    ]);
}
